var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationsEnvSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4755 7.16235C33.1439 3.83076 28.7126 2 24.0031 2C19.2871 2 14.8622 3.83076 11.5306 7.16235C8.19904 10.4939 6.36182 14.9253 6.36182 19.6348C6.36182 29.1638 15.3733 37.0949 20.2186 41.3516C20.8914 41.9467 21.4672 42.4578 21.933 42.8848C22.5152 43.4282 23.2591 43.6999 24.0031 43.6999C24.747 43.6999 25.491 43.4282 26.0667 42.8848C26.5325 42.4578 27.1147 41.9467 27.7875 41.3516C32.6264 37.0949 41.6379 29.1638 41.6379 19.6348C41.6379 14.9253 39.8071 10.4939 36.4755 7.16235Z",
    fill: "#E0791A",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8767 14.9332C32.3798 14.9332 35.2169 14.6124 35.2169 14.2178L33.6874 12.8115C33.6134 12.9595 33.3174 13.0829 32.2071 13.2063C31.319 13.3049 30.1348 13.3543 28.8765 13.3543C27.6184 13.3543 26.4341 13.3049 25.5459 13.2063C24.4358 13.0829 24.1397 12.9349 24.0656 12.8115L22.5361 14.2178C22.5361 14.6126 25.3733 14.9332 28.8764 14.9332H28.8767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5637 12.7135C33.5637 12.9997 31.4651 13.2315 28.8763 13.2315C26.2874 13.2315 24.189 12.9997 24.189 12.7135C24.189 12.4273 26.2876 12.1953 28.8763 12.1953C31.465 12.1953 33.5637 12.4273 33.5637 12.7135Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3911 14.8597C32.1822 15.0077 30.5785 15.0817 28.8764 15.0817C27.1741 15.0817 25.5706 15.0077 24.3864 14.8844C24.263 14.8597 24.1396 14.8597 24.0164 14.835L22.5361 16.1919C22.5361 16.5866 25.3731 16.9072 28.8764 16.9072C32.3796 16.9072 35.2167 16.5865 35.2167 16.1919L33.7364 14.835C33.6376 14.8351 33.5142 14.8597 33.391 14.8597H33.3911Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8269 21.6442C28.3581 21.6442 27.9388 21.6195 27.5934 21.5948C27.3714 21.5702 27.2234 21.5454 27.1494 21.5208V28.7245C27.248 28.7985 27.8648 28.8725 28.8269 28.8725C29.789 28.8725 30.3812 28.7739 30.5044 28.7245V21.4961C30.4058 21.5207 30.2824 21.5455 30.0604 21.5701C29.715 21.6195 29.2709 21.6441 28.8269 21.6441V21.6442Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8273 19.0536C27.9145 19.0536 27.051 19.0042 26.3849 18.9302C25.9409 18.881 25.6941 18.8316 25.5215 18.7822L27.125 21.3478C27.199 21.4218 27.8157 21.4958 28.8025 21.4958C29.7892 21.4958 30.4059 21.3972 30.4799 21.3478L32.1084 18.7822C31.9604 18.8316 31.689 18.8808 31.2449 18.9302C30.6035 19.0044 29.74 19.0536 28.8272 19.0536H28.8273Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8271 28.9962C28.3584 28.9962 27.939 28.9716 27.5936 28.9468C27.4208 28.9222 27.2976 28.8975 27.2236 28.8975L27.9638 30.205V32.4747C27.9638 32.9186 28.2846 33.3134 28.7039 33.3628C29.2221 33.4368 29.6661 33.0174 29.6661 32.524V30.205L30.4062 28.9221C30.3076 28.9467 30.2088 28.9715 30.0362 28.9715C29.7153 28.9716 29.2712 28.9963 28.8272 28.9963L28.8271 28.9962Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4473 16.9077V18.5852C25.5953 18.7086 26.8536 18.906 28.827 18.906C30.8007 18.906 32.0588 18.7332 32.2068 18.5852V16.9077C31.1953 16.9817 30.0358 17.0311 28.827 17.0311C27.5935 17.0311 26.434 16.9817 25.4473 16.9077Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2517 20.7071C23.1777 20.7317 23.1283 20.7317 23.0543 20.7565C23.1777 21.2004 23.2517 21.7432 23.2517 22.3599L19.5265 23.0507C19.4525 22.6807 19.1317 22.3846 18.737 22.3846C18.6383 22.3846 18.5396 22.4092 18.4656 22.434L16.9853 19.8929C17.1827 19.5969 17.3306 19.2515 17.3553 18.8814C17.4293 17.9933 16.9113 17.1545 16.0971 16.8338C15.6531 16.661 15.1844 16.6364 14.765 16.7598C14.8884 17.2779 14.9624 17.9193 14.9624 18.6347C14.9624 19.4242 14.8638 20.1395 14.7156 20.6823C15.3818 20.8797 16.0477 20.7317 16.5659 20.3615L18.0214 22.8532C17.972 22.9766 17.9228 23.0999 17.9228 23.2232V23.4945L15.283 25.0488C15.3076 24.654 15.3816 24.2841 15.4558 23.9633C15.3818 23.9387 15.3324 23.9139 15.2584 23.9139C14.1482 23.6671 13.0381 24.4072 12.816 25.5422C12.6186 26.6029 13.3341 27.6884 14.3949 27.9106C14.7648 27.9846 15.135 27.96 15.4556 27.8366C15.3076 27.2939 15.2088 26.5537 15.2088 25.7395L17.8732 24.1606V32.4992C17.8732 32.9186 18.194 33.3133 18.6134 33.3379C19.1067 33.3873 19.5015 32.9926 19.5015 32.5238L19.5017 23.643L23.2022 22.9522C23.1776 23.5936 23.1036 24.1857 22.9554 24.6297C23.3008 24.7531 23.6462 24.7777 24.0162 24.7037C25.0769 24.4817 25.7924 23.4208 25.5951 22.3353C25.4719 21.2007 24.3863 20.4605 23.2516 20.7071L23.2517 20.7071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4726",
    x: 0.861816,
    y: 0.5,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4726",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsEnvSensor);
export default __webpack_public_path__ + "static/media/operationsEnvSensor.848de1b44b0d7643663cc958561e6fb4.svg";
export { ForwardRef as ReactComponent };